<template>
	<div class='knd-story' >
		<Intro />
		<div v-if="!show" style="height: 50vh"></div>
		<Ranglijst v-if='show'/> 

		<Inkomsten v-if='show'/> 

		<div v-for="(thema, index) in themes" :key="thema.title" >
			<Thema 
				:title="thema.title" 
				:label="thema.label"
				:number="index"
			>	
			</Thema>
		</div>

		<Eindscherm v-if='showEndScreen' />


		<Graphic />

	</div>
</template>

<script>
import Intro from '@/story/intro';
import Ranglijst from '@/story/ranglijst';
import Inkomsten from '@/story/inkomsten';
import Thema from '@/story/thema';
import Eindscherm from '@/story/eindscherm';

import Graphic from '@/story/graphic/index.vue';

export default {
	name: 'App',
	watch:{
		detail:function(newVal,oldVal){
			if(newVal) {
				this.show = true;
			} else {
				this.show = false;
			}
		},

		themes: function(newVal) {
		}
	},
	computed: {
		showEndScreen() {
			return this.$store.getters.showEndScreen;
		},

		gemeente() {
			return this.$store.getters.selectedGemeente.gemeente_naam;
		},

		detail() {
			return this.$store.getters.selectedGemeente.detail;
		},

		themes() {
			return this.$store.getters.themes;
		}		
	
	},	
	components: {Intro, Ranglijst, Inkomsten, Graphic, Thema, Eindscherm},
	data: function() {
		return {
			show: false
		}
	},
	mounted: function() {},
	methods: {}
}
</script>
